// TODO fix type errors

// @ts-nocheck
import type { FiatPrice } from "@b2bportal/air-booking-api";
import {
  hsbcAccountsApi,
  type RewardsAccountResponse,
} from "@b2bportal/hsbc-accounts-api";
import {
  hsbcPaymentApi,
  type RewardsConversionResponse,
} from "@b2bportal/hsbc-payment-api";
import { axiosInstance } from "@hopper-b2b/api";
import { logger } from "@hopper-b2b/datadog";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/**
 * Main reason to use this RTK query is for it is auto caching feature.
 * However, we can only access query via hook, which is leading to some issues.
 * e.g.
 * - Harder to control the logic in the component and cant trigger explicitly
 * - It can lead to extra query (and maybe introduce extra re-render).
 */
export const accountRewardsApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: "/",
  }),
  reducerPath: "accountRewards",
  tagTypes: ["RewardsAccount"],

  endpoints: (build) => ({
    getAccountsRewards: build.query<RewardsAccountResponse, void>({
      queryFn: async () => {
        try {
          const { data } =
            await hsbcAccountsApi(axiosInstance).apiV0AccountsRewardsPost();

          return { data };
        } catch (error) {
          logger()?.error("Error fetching account rewards:", error);
          return { error: { status: "FETCH_ERROR", data: error } };
        }
      },
      providesTags: ["RewardsAccount"],
    }),
    convertPointsToCash: build.query<RewardsConversionResponse, number>({
      queryFn: async (numberOfPoints) => {
        try {
          if (!(numberOfPoints > 0))
            return {
              data: undefined,
            };

          const { data } = await hsbcPaymentApi(
            axiosInstance
          ).apiV0PaymentRewardsConversionPost({
            RewardsConversionRequest: "GetCashEquivalent",
            numberOfPoints: Number(numberOfPoints),
          });

          return { data };
        } catch (error) {
          logger()?.error("Error converting points to cash:", error);
          return { error: { status: "CONVERSION_ERROR", data: error } };
        }
      },
    }),
    convertCashToPoints: build.query<RewardsConversionResponse, FiatPrice>({
      queryFn: async (cashAmount) => {
        try {
          if (!(cashAmount?.value > 0))
            return {
              data: undefined,
            };
          const { data } = await hsbcPaymentApi(
            axiosInstance
          ).apiV0PaymentRewardsConversionPost({
            RewardsConversionRequest: "GetPointsEquivalent",
            cashAmount,
          });

          return { data };
        } catch (error) {
          logger()?.error("Error converting cash to points:", error);
          return { error: { status: "CONVERSION_ERROR", data: error } };
        }
      },
    }),
  }),
});

export const {
  useGetAccountsRewardsQuery,
  useConvertPointsToCashQuery,
  useConvertCashToPointsQuery,
} = accountRewardsApi;

export default accountRewardsApi;
